(() => {
  'use strict';

  const selector = 'img[src^="/api/skin-texture"], img[data-required-preview="true"]';

  function prepare(image) {
    if (!(image instanceof HTMLImageElement) || image.dataset.skinQualityBound === 'true') return;
    image.dataset.skinQualityBound = 'true';
    const card = image.closest('.project-card');
    if (!card) return;
    card.classList.add('preview-pending');
    card.setAttribute('data-requires-preview', 'true');

    const reveal = () => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      card.classList.remove('preview-pending');
      card.setAttribute('data-preview-ready', 'true');
    };
    const remove = () => {
      const grid = card.closest?.('.card-grid');
      card.remove();
      if (grid && !grid.querySelector('.project-card')) {
        const notice = document.createElement('div');
        notice.className = 'panel empty-state';
        notice.innerHTML = '<h3>Verified previews are temporarily unavailable</h3><p>No unverified or broken skin card is shown. Try again later or open the official skin source.</p>';
        grid.append(notice);
      }
    };

    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', remove, { once: true });
    if (image.complete) queueMicrotask(image.naturalWidth ? reveal : remove);
  }

  document.querySelectorAll(selector).forEach(prepare);
})();
